import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ChainedBackend from 'i18next-chained-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import { DateTime } from 'luxon'

const trimSlashes = (str:string) => str.replace(/^\/|\/$/g, '')

const localeBasePath =  trimSlashes(import.meta.env.BASE_URL + "locales")

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      format: (value, formatting, lng) => {
        if (value instanceof DateTime) {
          return value.setLocale(lng || 'fr').toFormat(formatting || '')
        }
        return value
      },
    },
    load: 'languageOnly',
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lng',
    },
    supportedLngs: ['fr', 'en'],
    fallbackLng: ['fr'],
    debug: false,
    ns: ['app', 'errors', 'global'],
    defaultNS: 'app',
    backend: {
      backends: [
        HttpApi,
        resourcesToBackend((language, namespace, callback) => {
          import(`./${localeBasePath}/${language}/${namespace}.${language}.json`)
            .then(({ default: resources }) => {
              callback(null, resources)
            })
            .catch((error) => {
              callback(error, null)
            })
        }),
      ],
      backendOptions: [
        {
          loadPath: `/${localeBasePath}/{{lng}}/{{ns}}.{{lng}}.json`,
        },
      ],
    },
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: ['strong'],
    },
  })

export default i18n
